if (!customElements.get('product-media-flip')) {
  customElements.define(
    'product-media-flip',
    class ProductMediaFlip extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('[data-flip-wrapper]');
        this.toggle = this.querySelector('[data-flip-toggle]');

        if (!this.wrapper || !this.toggle) return;

        this.isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        this.active = false;

        this.onActivate = () => this.setActive(true);
        this.onDeactivate = () => this.setActive(false);
        this.onClick = (event) => {
          event.preventDefault();
          this.setActive(!this.active);
        };

        if (this.isTouch) {
          this.toggle.addEventListener('click', this.onClick);
        } else {
          this.toggle.addEventListener('mouseenter', this.onActivate);
          this.toggle.addEventListener('mouseleave', this.onDeactivate);
          this.toggle.addEventListener('focus', this.onActivate);
          this.toggle.addEventListener('blur', this.onDeactivate);
        }
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('mouseenter', this.onActivate);
        this.toggle?.removeEventListener('mouseleave', this.onDeactivate);
        this.toggle?.removeEventListener('focus', this.onActivate);
        this.toggle?.removeEventListener('blur', this.onDeactivate);
        this.toggle?.removeEventListener('click', this.onClick);
      }

      setActive(active) {
        this.active = active;
        this.wrapper.classList.toggle('is-showing-alternate', active);
        this.toggle.classList.toggle('is-active', active);
        this.toggle.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }
  );
}
